import Container from "react-bootstrap/Container";
import { Row, Col, Card, Form, Spinner } from "react-bootstrap";
import React, { useState, useEffect } from "react";
import { fetchUserBadges } from "../../Providers/CatalogDataService";
import { FaShareAlt } from "react-icons/fa";
import HexagonBadge from "./HexagonBadge";
import "./Badge.css";

// Replace this hardcoded data
const hardcodedBadges = [
  {
    issued: "13 May 2025, 11:25 AM",
    key: "launch1",
    name: "Frictionless Enterprise",
    tag: "Launch course",
  },
  {
    issued: "01 April 2025, 11:25 AM",
    key: "launch2",
    name: "What is Launch by NTT DATA?",
    tag: "Launch course",
  },
  {
    issued: "17 April 2025, 11:25 AM",
    key: "launch3",
    name: "Engineering at Launch",
    tag: "Launch course",
  },
];

const Badge = () => {
  const [badges, setBadges] = useState({ badgeList: [], badgeYears: [] });
  const [selectedYear, setSelectedYear] = useState("0");
  const [selectedAllBadge, setSelectedAllBadge] = useState("all");
  const [filteredBadges, setFilteredBadges] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const loadBadges = async () => {
      try {
        setLoading(true);
        const response = await fetchUserBadges();
        if (response && response.badgeYears && response.badgeList) {
          setBadges(response);
          setFilteredBadges(
            Array.isArray(response.badgeYears) ? response.badgeYears : [],
          );
        }
      } catch (error) {
        console.error("Error fetching badges:", error);
      } finally {
        setLoading(false);
      }
    };

    loadBadges();
  }, []);
  useEffect(() => {
    if (selectedYear !== "0") {
      sessionStorage.setItem("selectedYear", selectedYear);
    }

    let allBadges = [
      ...(Array.isArray(badges.badgeList) ? badges.badgeList : []),
    ];

    if (selectedAllBadge === "launch-badges") {
      allBadges = [...hardcodedBadges];
    } else if (selectedAllBadge === "Nttdata-badges") {
      allBadges = Array.isArray(badges.badgeList) ? badges.badgeList : [];
    } else {
      allBadges = [
        ...(Array.isArray(badges.badgeList) ? badges.badgeList : []),
        ...hardcodedBadges,
      ];
    }

    if (selectedYear === "all" || selectedYear === "0") {
      setFilteredBadges(allBadges);
    } else {
      const filtered = allBadges.filter((badge) => {
        if (badge?.issued) {
          const issueDate = new Date(badge.issued);
          const issueYear = issueDate.getFullYear();

          const yearRange = badges.badgeYears.find(
            (y) => y.value === selectedYear,
          );
          if (yearRange) {
            const [startYear] = yearRange.text
              .split(" - ")[0]
              .trim()
              .split("/");
            return issueYear.toString() === startYear;
          }
        }
        return false;
      });
      setFilteredBadges(filtered);
    }
  }, [selectedYear, selectedAllBadge, badges.badgeList, badges.badgeYears]);

  const handleShare = (badge) => {
    console.log("Sharing badge:", badge);
  };

  return (
    <div className="card-container">
      <div className="container">
        <div className="arrow-course">
          <a href="#">
            <img src="assets/images/arrowLeft.png" alt="back" />
          </a>
        </div>
        <div className="row">
          <div className="col-1 text-start">
            <div className="launch-course">Launchified</div>
          </div>
          <div className="w-100"></div>
          <div className="col-6 text-start">
            <div className="completed-courses">My Badges</div>
          </div>
        </div>
        <br />
      </div>

      <Container className="filter-container">
        <Row className="mb-4">
          <Col xs={12} sm={3} className="mb-3 mb-sm-0">
            <Form.Group>
              <Form.Label>My Badge</Form.Label>
              <Form.Select
                value={selectedYear}
                onChange={(e) => setSelectedYear(e.target.value)}
                disabled={loading}
              >
                {badges.badgeYears && badges.badgeYears.length > 0 ? (
                  <>
                    {badges.badgeYears.find((year) => year.value === "0") && (
                      <option value="0">
                        {
                          badges.badgeYears.find((year) => year.value === "0")
                            .text
                        }
                      </option>
                    )}

                    {badges.badgeYears
                      .filter((year) => year.value !== "0")
                      .sort((previousYear, currentYear) => {
                        const previousYearValue = parseInt(
                          previousYear.text.split(" - ")[0],
                        );
                        const currentYearValue = parseInt(
                          currentYear.text.split(" - ")[0],
                        );
                        return currentYearValue - previousYearValue;
                      })
                      .map((year) => (
                        <option key={year.value} value={year.value}>
                          {year.text}
                        </option>
                      ))}
                  </>
                ) : (
                  <option value="0">All Dates</option>
                )}
              </Form.Select>
            </Form.Group>
          </Col>
          <Col xs={12} sm={3}>
            <Form.Group>
              <Form.Label>All Badge</Form.Label>
              <Form.Select
                value={selectedAllBadge}
                onChange={(e) => setSelectedAllBadge(e.target.value)}
              >
                <option value="all">All Badges</option>
                <option value="Nttdata-badges">NTTData Badges</option>
                <option value="launch-badges">Launch Badges</option>
              </Form.Select>
            </Form.Group>
          </Col>
        </Row>
      </Container>
      <Container className="badges-container">
        {loading ? (
          <div className="d-flex justify-content-center align-items-center w-100">
            <Spinner animation="border" role="status">
              <span className="visually-hidden">Loading...</span>
            </Spinner>
          </div>
        ) : (
          <Row>
            {Array.isArray(filteredBadges) && filteredBadges.length > 0 ? (
              filteredBadges.map((badge, index) => (
                <Col xs={12} key={badge.key || index}>
                  <Card className="badge-card">
                    <div className="badge-content">
                      {badge.tag === "Launch course" ? (
                        <HexagonBadge>
                          <div className="badge-header">
                            <span className="badge-title">Launch</span>
                            <span className="badge-subtitle">academy</span>
                          </div>
                          <div className="badge-details">
                            <span className="certified-text">CERTIFIED</span>
                            <span className="certificate-title">
                              YOU ARE NOW LAUNCHIFIED
                            </span>
                          </div>
                        </HexagonBadge>
                      ) : (
                        <div className="nttdata-badge">
                          <img
                            src={badge.image || "assets/images/nttdataLogo.png"}
                            alt={badge.name}
                            className="nttdata-badge-image"
                          />
                        </div>
                      )}
                      <div className="badge-info">
                        <span>{badge.tag}</span>
                        <h5 className="certificate-name">{badge.name}</h5>
                      </div>
                    </div>
                    <Card.Footer className="d-flex justify-content-between align-items-center">
                      <small className="text-muted">
                        Completed on:{" "}
                        {badge.issued
                          ? new Date(badge.issued).toLocaleDateString("en-GB", {
                              day: "2-digit",
                              month: "2-digit",
                              year: "numeric",
                            })
                          : "N/A"}
                      </small>
                      <button
                        className="share-button"
                        onClick={() => handleShare(badge)}
                      >
                        <FaShareAlt />
                      </button>
                    </Card.Footer>
                  </Card>
                </Col>
              ))
            ) : (
              <Col xs={12}>
                <div className="badges-notfound">
                  <p>No badges found</p>
                </div>
              </Col>
            )}
          </Row>
        )}
      </Container>
    </div>
  );
};

export default Badge;
